




















import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

@Component
export default class ComponentDialogModalLayout extends Vue {
  @Prop({ required: true })
  readonly value: boolean;
}
